import React, { useEffect, useRef, useState } from 'react'
import { useHistory, withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'

import {
  AutenticacaoContainer,
  Botao,
  Breadcrumb,
  Cabecalho,
  Carregando,
  FormUnform,
  IconeBack,
  IconeDoAvatarDoUsuario,
  Link,
  SubTitulo,
  TabelaDados,
  TabelaResposta,
  Visao
} from 'src/componentes'
import {
  TabelaDinamica,
  TabelaDinamicaRef
} from 'src/componentes/tabela-dinamica'
import { RotasAcademico } from 'src/rotas'
import { Api } from 'src/servicos'
import { Nacionalidade, UsuarioSituacao } from 'src/tipos'

import {
  AbaContratos,
  AbaInformacoesAcesso,
  AbaMatricula,
  AbaNotas,
  AccordionInformacoesAluno
} from '../edicao/componentes'
import {
  colunaDataInicio,
  colunaSituacao,
  colunaSituacaoFinanceira,
  colunaTipo,
  colunaTurma
} from './componentes/colunas'
import {
  Container,
  ContainerImagemAluno,
  ContainerLink,
  Conteudo,
  ImagemAluno
} from './styles'
import { Aluno, MatriculaAluno, PaginaCertificarAlunoProps } from './tipos'

export const CertificarAluno: React.FC<PaginaCertificarAlunoProps> = ({
  match
}) => {
  const history = useHistory()
  const { visao } = AutenticacaoContainer.useContainer()
  const [aluno, definirAluno] = useState<Aluno>(null)
  const [pronto, definirPronto] = useState(false)
  const [estrangeiro, definirEstrangeiro] = useState(false)
  const tabelaDinamicaRef = useRef<TabelaDinamicaRef>()

  const carregarAluno = async () => {
    try {
      const aluno = await Api.ObterAlunoPorId(match.params.id)
      definirAluno(aluno)

      const ehEstrangeiro = aluno.nacionalidade === Nacionalidade[1]
      definirEstrangeiro(ehEstrangeiro)
    } catch (error) {
      toast('Houve um problema ao obter os dados do aluno', {
        type: 'error'
      })
    } finally {
      definirPronto(true)
    }
  }

  const acaoSucesso = async (matriculaId: string) => {
    try {
      definirPronto(false)

      await Api.CertificarAluno(matriculaId)
    } catch (e) {
      toast('Houve um problema ao obter os dados do aluno', {
        type: 'error'
      })
    } finally {
      toast('Certificado do aluno emitido', {
        type: 'success'
      })
      definirPronto(true)
    }
  }

  const obterDadosTurma = async (): Promise<TabelaResposta | null> => {
    return {
      Dados: aluno.matriculaTurma
    } as TabelaResposta
  }

  useEffect(() => {
    if (visao === Visao.Parceiro) {
      history.replace(RotasAcademico.Alunos)
      return
    }

    carregarAluno()
  }, [visao])

  return (
    <>
      {pronto ? (
        <Container>
          <ContainerLink>
            <Link
              texto="Voltar"
              icone={IconeBack}
              acaoVoltar={() => history.goBack()}
            />
          </ContainerLink>
          <Cabecalho>
            <Breadcrumb
              titulo="Certificação do Aluno"
              atalhos={[
                {
                  texto: 'Acadêmico'
                },
                {
                  texto: 'Alunos',
                  acao: () => history.goBack()
                },
                {
                  texto: 'Certificação do Aluno'
                }
              ]}
            />
          </Cabecalho>
          <Conteudo>
            {aluno ? (
              <>
                <SubTitulo texto="Dados do Aluno" />
                <FormUnform
                  dadosIniciais={{
                    situacao: UsuarioSituacao[aluno.situacao]
                  }}
                  acaoSucesso={null}
                >
                  <ContainerImagemAluno>
                    {aluno.foto ? (
                      <ImagemAluno src={aluno.foto} alt="Imagem do aluno" />
                    ) : (
                      IconeDoAvatarDoUsuario
                    )}
                  </ContainerImagemAluno>
                </FormUnform>
                <AccordionInformacoesAluno
                  aluno={aluno}
                  ehEstrangeiro={estrangeiro}
                />
                <div style={{ marginBottom: '56px' }} />
                <TabelaDinamica
                  Abas={[
                    {
                      titulo: 'Matrícula',
                      conteudoTabela: [
                        {
                          Renderizar: (linha: TabelaDados) => (
                            <AbaMatricula
                              informacoes={linha as MatriculaAluno}
                            />
                          )
                        }
                      ]
                    },
                    {
                      titulo: 'Informações de Acesso',
                      conteudoTabela: [
                        {
                          Renderizar: (linha: TabelaDados) => (
                            <AbaInformacoesAcesso
                              informacoes={linha as MatriculaAluno}
                            />
                          )
                        }
                      ]
                    },
                    {
                      titulo: 'Notas',
                      conteudoTabela: [
                        {
                          Renderizar: (linha: TabelaDados) => (
                            <AbaNotas
                              matriculaId={linha.matriculaId}
                              tipoAvaliacao={linha.tipoAvaliacao}
                            />
                          )
                        }
                      ]
                    },
                    {
                      titulo: 'Contratos',
                      conteudoTabela: [
                        {
                          Renderizar: (linha: TabelaDados) => (
                            <AbaContratos matriculaId={linha.matriculaId} />
                          )
                        }
                      ]
                    }
                  ]}
                  ref={tabelaDinamicaRef}
                  Colunas={[
                    colunaTurma(),
                    colunaDataInicio(),
                    colunaSituacao(),
                    colunaTipo(),
                    colunaSituacaoFinanceira(),
                    {
                      Chave: 'acoes',
                      Alinhamento: 'center',
                      StyleColuna: { width: 100, paddingInline: 15 },
                      Renderizar: (linha: TabelaDados) => {
                        const modalidadeArray = ['Extensão', 'Evento', 'Outra']

                        return modalidadeArray.includes(linha.modalidade) ? (
                          <></>
                        ) : (
                          <Botao
                            type="button"
                            texto="Certificar"
                            onClick={() => acaoSucesso(linha.matriculaId)}
                            /* disabled={
                          linha.situacaoFinanceira !== 'Finalizado' ||
                          !aluno.validaDocumentos ||
                          !aluno.alunoNota?.find(
                            n => n.matriculaId === linha.matriculaId
                          )?.certificacao
                        } */
                            style={{
                              width: '100%',
                              margin: '20px 10px 20px 0px'
                            }}
                          />
                        )
                      }
                    }
                  ]}
                  ObterDados={obterDadosTurma}
                />
              </>
            ) : (
              <p>Não foi possível carregar os dados do aluno.</p>
            )}
          </Conteudo>
        </Container>
      ) : (
        <Carregando />
      )}
    </>
  )
}

export default withRouter(CertificarAluno)
